import { render, staticRenderFns } from "./appDesc.vue?vue&type=template&id=6095cd0a&scoped=true&"
import script from "./appDesc.vue?vue&type=script&lang=js&"
export * from "./appDesc.vue?vue&type=script&lang=js&"
import style0 from "./appDesc.vue?vue&type=style&index=0&id=6095cd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6095cd0a",
  null
  
)

export default component.exports